/* Panier tiroir. API panier de Shopify en AJAX, puis re-rendu de la section
   par l'API de rendu de sections : le seuil, la jauge et l'échantillon restent
   calculés côté Liquid, à un seul endroit. */
(function () {
  var SECTION = 'panier-tiroir';
  var tiroir = document.querySelector('[data-tiroir]');
  if (!tiroir) return;
  SECTION = tiroir.getAttribute('data-section-id') || SECTION;
  var enCours = false;
  var retourFocus;
  var fondsInertes = [];
  var racine = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function isoler() {
    var enfant = tiroir;
    while (enfant && enfant.parentElement) {
      Array.from(enfant.parentElement.children).forEach(function (el) {
        if (el !== enfant && !el.inert && !/^(SCRIPT|STYLE|LINK)$/.test(el.tagName)) {
          el.inert = true; fondsInertes.push(el);
        }
      });
      enfant = enfant.parentElement;
      if (enfant === document.body) break;
    }
  }

  function verifier(r) {
    return r.json().catch(function () { return {}; }).then(function (data) {
      if (!r.ok) {
        var refus = new Error(data.description || data.message || 'Le panier n’a pas pu être mis à jour. Vérifiez votre sélection.');
        refus.panierRefuse = true;
        refus.status = r.status;
        throw refus;
      }
      return data;
    });
  }
  function erreur(e) {
    var zone = document.querySelector('[data-erreur-panier]');
    if (!zone) {
      zone = document.createElement('p');
      zone.setAttribute('data-erreur-panier', '');
      zone.setAttribute('role', 'alert');
      (tiroir.hidden ? document.querySelector('main') : tiroir.querySelector('.tiroir__panneau')).prepend(zone);
    }
    zone.textContent = e.message || 'Connexion interrompue. Vérifiez votre panier avant de réessayer.';
  }

  function statutAjout(form, texte, estErreur, lienPanier) {
    var zone = form.querySelector('[data-ajout-statut]');
    if (!zone) {
      zone = document.createElement('p');
      zone.setAttribute('data-ajout-statut', '');
      form.appendChild(zone);
    }
    zone.hidden = false;
    zone.setAttribute('role', estErreur ? 'alert' : 'status');
    zone.setAttribute('aria-atomic', 'true');
    zone.textContent = texte;
    if (lienPanier) {
      var lien = document.createElement('a');
      lien.href = racine + 'cart';
      lien.setAttribute('data-panier-direct', '');
      lien.textContent = 'Voir mon panier';
      zone.appendChild(document.createTextNode(' '));
      zone.appendChild(lien);
    }
  }

  function ouvrir(declencheur) {
    if (tiroir.hidden) {
      retourFocus = declencheur || document.activeElement;
      var entete = document.querySelector('[data-entete]');
      var menu = entete && entete.querySelector('[data-menu-mobile]');
      if (menu && !menu.hidden) {
        entete.dispatchEvent(new CustomEvent('chanoyu:menu-fermer'));
        retourFocus = entete.querySelector('[data-panier-mobile]') || entete.querySelector('[data-ouvre-menu]');
      }
      isoler();
    }
    tiroir.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var premier = tiroir.querySelector('.tiroir__titre');
    if (premier) premier.focus();
  }
  function fermer() {
    tiroir.hidden = true;
    fondsInertes.forEach(function (el) { el.inert = false; });
    fondsInertes = [];
    document.documentElement.style.overflow = '';
    if (retourFocus && retourFocus.isConnected) {
      var cibleFocus = retourFocus;
      if (cibleFocus.disabled && cibleFocus.form) cibleFocus = cibleFocus.form.querySelector('input:checked:not(:disabled), input[name="quantity"]:not(:disabled), button:not(:disabled)');
      if (cibleFocus) cibleFocus.focus();
    }
  }

  function rafraichir() {
    /* deux pièges ici :
       - sans no-store, le navigateur sert une version périmée du tiroir ;
       - avec un en-tête Accept: application/json, une URL produit renvoie le JSON
         du produit et « sections » est ignoré. On n'envoie donc aucun Accept. */
    var url = new URL(window.location.href);
    url.searchParams.set('sections', SECTION);
    url.searchParams.set('_', Date.now());
    return fetch(url.toString(), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION];
        if (!html) throw new Error('Actualisation impossible. Rechargez la page pour voir votre panier.');
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var neuf = doc.querySelector('[data-tiroir]');
        var actuel = document.querySelector('[data-tiroir]');
        if (!neuf || !actuel) throw new Error('Actualisation impossible. Rechargez la page pour voir votre panier.');
        var etaitOuvert = !actuel.hidden;
        var avaitFocus = actuel.contains(document.activeElement);
        actuel.innerHTML = neuf.innerHTML;
        tiroir = actuel;
        if (etaitOuvert) actuel.hidden = false;
        if (etaitOuvert && avaitFocus) actuel.querySelector('.tiroir__titre').focus();
        majCompteur();
      });
  }

  function majCompteur() {
    fetch(racine + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        document.querySelectorAll('[data-panier-compte]').forEach(function (el) {
          el.textContent = panier.item_count;
        });
        document.querySelectorAll('a[href$="/cart"]').forEach(function (a) {
          if (a.hasAttribute('data-panier-mobile')) a.setAttribute('aria-label', 'Panier (' + panier.item_count + ')');
          else if (/Panier/.test(a.textContent)) a.textContent = 'Panier (' + panier.item_count + ')';
        });
      })
      .catch(function () { /* le compteur n'est pas critique */ });
  }

  function changer(cle, quantite) {
    if (enCours) return;
    enCours = true;
    fetch(racine + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: cle, quantity: quantite })
    }).then(verifier).then(rafraichir).catch(erreur).then(function () { enCours = false; });
  }

  function ajouter(varianteId) {
    if (enCours || !varianteId) return;
    enCours = true;
    fetch(racine + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: varianteId, quantity: 1 }] })
    }).then(verifier).then(rafraichir).then(ouvrir).catch(erreur).then(function () { enCours = false; });
  }

  function noter(texte) {
    fetch(racine + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ note: texte })
    }).then(verifier).catch(erreur);
  }

  /* délégation : le contenu du tiroir est remplacé à chaque mise à jour */
  document.addEventListener('click', function (e) {
    var cible = e.target;

    if (cible.closest('[data-fermer]')) { fermer(); return; }

    var lienPanier = cible.closest('a[href$="/cart"], a[href*="/cart?"]');
    if (lienPanier && !lienPanier.hasAttribute('data-panier-direct') && !cible.closest('.tiroir__pied') && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && !e.button) { e.preventDefault(); ouvrir(lienPanier); return; }

    var moins = cible.closest('[data-moins]');
    var plus = cible.closest('[data-plus]');
    if (moins || plus) {
      var ligne = cible.closest('[data-cle]');
      if (!ligne) return;
      var q = parseInt(ligne.querySelector('[data-qte]').textContent, 10) || 1;
      changer(ligne.getAttribute('data-cle'), plus ? q + 1 : q - 1);
      return;
    }

    var sugg = cible.closest('[data-ajouter]');
    if (sugg) { ajouter(sugg.getAttribute('data-ajouter')); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && tiroir && !tiroir.hidden) fermer();
    if (e.key === 'Tab' && !tiroir.hidden) {
      var panneau = tiroir.querySelector('.tiroir__panneau');
      var elements = Array.from(panneau.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), textarea'))
        .filter(function (el) { return el.getClientRects().length; });
      var premier = elements[0], dernier = elements[elements.length - 1];
      if (!premier) { e.preventDefault(); return; }
      if (e.shiftKey && (document.activeElement === premier || !elements.includes(document.activeElement))) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && (document.activeElement === dernier || !elements.includes(document.activeElement))) { e.preventDefault(); premier.focus(); }
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-note]')) noter(e.target.value);
  });

  /* les formulaires produit ouvrent le tiroir au lieu de recharger la page */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action$="/cart/add"]')) return;
    e.preventDefault();
    if (form.dataset.ajoutEnCours === 'true') return;
    if (enCours) { statutAjout(form, 'Le panier se met à jour. Réessayez dans un instant.', false); return; }
    if (e.submitter && e.submitter.disabled) return;
    var boutons = Array.from(document.querySelectorAll('button[type="submit"], button:not([type]), input[type="submit"]'))
      .filter(function (bouton) { return bouton.form === form || form.contains(bouton); })
      .map(function (bouton) { return { element: bouton, html: bouton.innerHTML, valeur: bouton.value, disabled: bouton.disabled }; });
    if (boutons.length && boutons.every(function (bouton) { return bouton.disabled; })) return;
    var donnees = new FormData(form);
    var declencheur = e.submitter || document.activeElement;
    var ajoutConfirme = false;
    enCours = true;
    form.dataset.ajoutEnCours = 'true';
    form.setAttribute('aria-busy', 'true');
    boutons.forEach(function (bouton) {
      bouton.element.disabled = true;
      if (bouton.element.tagName === 'INPUT') bouton.element.value = 'Ajout…';
      else bouton.element.textContent = 'Ajout…';
    });
    statutAjout(form, 'Ajout au panier en cours…', false);
    form.dispatchEvent(new CustomEvent('chanoyu:pdp-sync', { bubbles: true, detail: { busy: true } }));
    fetch(racine + 'cart/add.js', { method: 'POST', body: donnees, headers: { 'Accept': 'application/json' } })
      .then(function (r) { ajoutConfirme = r.ok; return verifier(r); })
      .then(rafraichir)
      .then(function () { statutAjout(form, 'Ajouté au panier.', false); ouvrir(declencheur); })
      .catch(function (e) {
        if (ajoutConfirme) {
          statutAjout(form, 'Ajout confirmé. Le panier n’a pas pu s’afficher. Vérifiez-le avant de renouveler l’ajout.', false, true);
          majCompteur();
        } else if (e.panierRefuse) {
          statutAjout(form, e.message + (e.status === 422 ? ' Vérifiez votre panier avant de modifier la quantité.' : ''), true, e.status === 422);
        } else {
          statutAjout(form, 'La connexion a été interrompue : l’ajout n’a pas pu être confirmé. Vérifiez votre panier avant de réessayer.', true, true);
        }
      })
      .finally(function () {
        enCours = false;
        delete form.dataset.ajoutEnCours;
        form.removeAttribute('aria-busy');
        boutons.forEach(function (bouton) {
          var libelleActuel = bouton.element.getAttribute('data-add-label');
          bouton.element.disabled = libelleActuel === null ? bouton.disabled : bouton.element.getAttribute('data-available') !== 'true';
          if (bouton.element.tagName === 'INPUT') bouton.element.value = libelleActuel === null ? bouton.valeur : libelleActuel;
          else if (libelleActuel === null) bouton.element.innerHTML = bouton.html;
          else bouton.element.textContent = libelleActuel;
        });
        /* La fiche recalcule l’état depuis la variante maintenant sélectionnée,
           qui a pu changer pendant la requête. */
        form.dispatchEvent(new CustomEvent('chanoyu:pdp-sync', { bubbles: true, detail: { busy: false, added: ajoutConfirme } }));
      });
  });

  /* l'ajout rapide depuis une carte prévient d'ici */
  document.addEventListener('chanoyu:panier-modifie', function () {
    rafraichir().then(ouvrir).catch(erreur);
  });

  majCompteur();
})();
